import { render, staticRenderFns } from "./MessageRecord.vue?vue&type=template&id=2193e38d"
import script from "./MessageRecord.vue?vue&type=script&lang=js"
export * from "./MessageRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports